<div class="card">
    <div class="header p-1">
      <img [src]="IconPath">
      <span class="mx-1">{{Title}}</span>
    </div>
    <div class="card-body">
      <div class="item" *ngFor="let item of Items; let i = index" (click)="navigateTo(item.Path)">
        <span>{{ item.Parent|translate }}&nbsp;/&nbsp;{{ item.ItemName|translate }}</span>
        <img
          *ngIf="ShowDeleteButton"
          src="assets/icons/material-symbols--delete.svg"
          class="img-float"
          alt="Delete Icon"
          (click)="DeleteItem(i, item.Path)">
      </div>
    </div>
  </div>